<template>
  <div class="space-y-2" v-bind="$attrs">
    <div
      class="flex items-center"
      v-for="(item, itemI) in itemsListSliced"
      :key="itemI"
    >
      <h4
        class="text-base leading-6 font-medium flex-1 cursor-pointer break-words"
      >
        {{ item.humanType }}
        <span class="text-bc-blue">{{ item.elementName }}</span>
      </h4>
      <span @click.stop="removeItem(item)"
        ><aw-icon icon="close" class="w-5 h-5  cursor-pointer"
      /></span>
    </div>

    <div
      v-show="itemsListLength > maxItems && showSliced"
      @click="showSliced = false"
      class="cursor-pointer"
    >
      {{ $t('Show more (+%count%)', { count: itemsListLength - maxItems }) }}
    </div>
    <div
      v-show="itemsListLength > maxItems && !showSliced"
      @click="showSliced = true"
      class="cursor-pointer"
    >
      {{ $t('Show less') }}
    </div>
  </div>
  <input
    type="hidden"
    name="bc_folder_id[]"
    v-for="folder in itemsTypesList.folders"
    :key="folder"
    :value="folder"
  />
  <input
    type="hidden"
    name="bc_document_id[]"
    v-for="document in itemsTypesList.documents"
    :key="document"
    :value="document"
  />
  <input
    type="hidden"
    name="bc_document_data_id[]"
    v-for="data in itemsTypesList.data"
    :key="data"
    :value="data"
  />
</template>

<script>
import { inject } from 'vue'
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
import useBcSelectedBasketStore from '@/frontapp/store/bcSelectedBasket'

export default {
  props: {
    basket: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'share',

    }
  },
  setup(props) {
    const allowedTypes = ['share', 'pdf', 'copy', 'copyElement', 'file']
    if (!allowedTypes.includes(props.type)) {
      throw 'SelectedItemsList type ' + props.type + ' is not allowed. Use one of: ' + allowedTypes.join(', ');
    }

    return {
      closeModal: inject('closeModal', null)
    }
  },
  data() {
    return {
      maxItems: 5,
      showSliced: true
    }
  },
  computed: {
    ...mapStores(useBcSelectedStore, useBcSelectedBasketStore, useBcDocumentStore),
    itemsListLength() {
      return this.itemsList.length
    },
    itemsListSliced() {
      if (this.showSliced) {
        return this.itemsList.slice(0, this.maxItems)
      } else {
        return this.itemsList
      }
    },
    itemsList() {
      return this[this.type + 'ItemsList']
    },
    itemsTypesList() {
      return this[this.type + 'TypesList']
    },
    shareSourceItems() {
      if (this.basket) {
        return this.bcSelectedBasketStore.selected
      } else {
        return this.bcSelectedStore.listSelectedRoots || []
      }
    },
    shareItemsList() {
      return this.shareSourceItems.map((element) => {
        const item = {
          element: this.basket ? element.element : element
        }

        if (this.basket) {
          item.id = element.id
        }

        if (item.element.type === 'document') {
          item.humanType = this.$t('Document') + ': '
          item.elementName = item.element.name
        
        } else if (item.element.type === 'folder') {
          item.humanType = this.$t('Folder') + ': '
          item.elementName = item.element.name
        
        } else if (item.element.type === 'page') {
          item.humanType = ''
          item.elementName = item.element.data.header

          const childrenSelected = this.basket
            ? element.children
            : this.bcSelectedStore.listSelectedChildrenRecursive(
                item.element.id
              )

          let files = []
          if (childrenSelected && childrenSelected.length > 0) {
            files = childrenSelected.filter((el) => {
              return el.type === 'file'
            })
          }

          if (files.length > 0) {
            item.elementName += ': ' + (files.length > 1 ? files.length + ' files' : files.length + ' file')
          }
        }

        return item
      })
    },
    shareTypesList() {
      const ret = {
        documents: [],
        folders: [],
        data: []
      }

      this.shareSourceItems.forEach((element) => {
        const item = this.basket ? element.element : element

        if (item.type === 'document') {
          ret.documents.push(item.id)
       
        } else if (item.type === 'folder') {
          ret.folders.push(item.id)
        
        } else if (item.type === 'page') {
          ret.data.push(item.id)

          const childrenSelected = this.basket
            ? element.children
            : this.bcSelectedStore.listSelectedChildrenRecursive(item.id)
          
          if (childrenSelected && childrenSelected.length > 0) {
            childrenSelected.forEach((el) => {
              ret.data.push(el.id)
            })
          }
        }
      })

      return ret
    },
    pdfItemsList() {
      return this.bcSelectedStore.listSelectedRoots.map((element) => {
        const item = {
          element
        }

        if (item.element.type === 'document') {
          item.humanType = this.$t('Document') + ': '
          item.elementName = item.element.name
        
        } else if (item.element.type === 'folder') {
          item.humanType = this.$t('Folder') + ': '
          item.elementName = item.element.name
        
        } else if (item.element.type === 'page') {
          item.humanType = ''
          item.elementName = item.element.data.header

          const childrenSelected = this.bcSelectedStore.listSelectedChildrenRecursive(item.element.id)

          if (childrenSelected.length > 0) {
            item.elementName += ': ' + (childrenSelected.length > 1 ? childrenSelected.length + ' elements' : childrenSelected.length + ' element')
          }
        }

        return item
      })
    },
    pdfTypesList() {
      const ret = {
        documents: [],
        folders: [],
        data: []
      }

      if (['BCSharedDocument',  'BCDocument'].includes(this.$route.matched[0].name) /*&&  this.bcSelectedStore.listSelectedRoots.length === 0*/) {
        ret.documents.push(this.bcDocumentStore.document.id)
      }

      this.bcSelectedStore.listSelectedRoots.forEach((element) => {
        const item = this.basket ? element.element : element

        if (item.type === 'document') {
          ret.documents.push(item.id)
       
        } else if (item.type === 'folder') {
          ret.folders.push(item.id)
        
        } else if (item.type === 'page') {
          ret.data.push(item.id)

          const childrenSelected = this.basket
            ? element.children
            : this.bcSelectedStore.listSelectedChildrenRecursive(item.id)
          
          if (childrenSelected && childrenSelected.length > 0) {
            childrenSelected.forEach((el) => {
              ret.data.push(el.id)
            })
          }
        }
      })

      return ret
    },
    copyItemsList() {
      // same as pdf
      return this.pdfItemsList
    },
    copyTypesList() {
      // same as pdf
      return this.pdfTypesList
    },
    copyElementItemsList() {
      return this.pdfItemsList
    },
    copyElementTypesList() {
      return {
        documents: [this.bcDocumentStore.document.id + ':' + this.bcDocumentStore.document.bc_document_rev_id],
        folders: [],
        data: this.bcSelectedStore.listFullySelected.map((element) => element.id)
      }
    },
    fileItemsList() {
      const ret = []

      this.bcSelectedStore.listSelected.forEach((element) => {
        if (element.type !== 'file' && this.$route.matched[0].name !== 'BCFile') {
          return
        }

        ret.push({
          element,
          humanType: '',
          elementName: this.$route.matched[0].name === 'BCFile' ? element.name : element.file.name,
        })
      })

      return ret 
    },
    fileTypesList() {
      return {
        files: this.fileItemsList.map((item) => this.$route.matched[0].name === 'BCFile' ? item.id : item.element.file.id)
      }
    }
  },
  methods: {
    removeItem(item) {
      if (this.basket) {
        this.bcSelectedBasketStore.removeFromBasket(item.id)
      } else {
        // realy no items is selected, select all items
        if (this.bcSelectedStore.listSelected.length === 0) {
          if (this.bcSelectedStore.defaultSelected === null) {
            this.bcSelectedStore.selectAll()
          } else if (this.bcSelectedStore.defaultSelected !== false) {
            // close modal only
            if (this.closeModal) {
              this.closeModal()
            }
            return
          }
        } else if (
          this.itemsList.length === 1 &&
          this.bcSelectedStore.defaultSelected !== false
        ) {
          // posledni odmazany
          if (this.closeModal) {
            this.closeModal()
          }
        }

        this.bcSelectedStore.select(item.element)
      }
    }
  },
  watch: {
    itemsList(newVal) {
      if (newVal.length === 0 && this.closeModal) {
        this.closeModal()
      }
    }
  }
}
</script>
